import React, { useState } from "react";
import { useI18n } from "../i18n/LanguageContext";
import { AviationForm } from "./AviationForm";
import { YachtForm } from "./YachtForm";
import { VillaForm } from "./VillaForm";

export const ServiceForms = ({ destinationName }) => {
  const { t } = useI18n();
  const [tab, setTab] = useState("aviation");

  const tabs = [
    { key: "aviation", label: t("aviation.label") },
    { key: "yacht", label: t("yachts.label") },
    { key: "villa", label: t("villas.label") },
  ];

  return (
    <div data-testid="service-forms">
      <div className="flex flex-wrap gap-2 mb-8">
        {tabs.map((tb) => (
          <button
            key={tb.key}
            onClick={() => setTab(tb.key)}
            className={`px-6 py-3 text-xs tracking-[0.18em] uppercase border transition-colors duration-300 ${tab === tb.key ? "border-vm-accent text-vm-accent bg-vm-accent/[0.06]" : "border-vm-border text-vm-text2 hover:text-vm-text"}`}
            data-testid={`service-tab-${tb.key}`}
          >
            {tb.label}
          </button>
        ))}
      </div>
      {tab === "aviation" && <AviationForm destinationName={destinationName} />}
      {tab === "yacht" && <YachtForm destinationName={destinationName} />}
      {tab === "villa" && <VillaForm destinationName={destinationName} />}
    </div>
  );
};
